import { useState, useEffect } from 'react';
import { API } from '@/utils/API';

export interface TermsData {
  id: string;
  title: string;
  content: string;
  version: string;
  effective_date: string;
  accepted?: boolean;
}

export const useTermsData = () => {
  const [termsData, setTermsData] = useState<TermsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadTermsData = async () => {
      try {
        setLoading(true);
        const response = await API.fetch('/terms');

        if (response.ok) {
          const data: TermsData = await response.json();
          setTermsData(data);
        } else {
          throw new Error('Failed to load terms and conditions');
        }
      } catch (e) {
        console.error('Error loading terms:', e);
        setError(
          e instanceof Error ? e.message : 'Failed to load terms and conditions'
        );
      } finally {
        setLoading(false);
      }
    };

    loadTermsData();
  }, []);

  return {
    termsData,
    loading,
    error,
  };
};
